module.exports = __webpack_public_path__ + "static/fonts/Miller-Text.92ceafd2.eot";